import React, { useState } from "react";
import LessonPlanningAssistant from "./LessonPlanningAssistant";
import LessonPlanningAssistantV2 from "./LessonPlanningAssistantV2";

import { getIsLessonPlanningAIRevampEnabled } from "./modules/Utils";
import { getIsAITutorModalitiesEnabled } from "Utils/ACLStoreUtils";

const LessonPlanningAssistantWrapper = props => {
  const { isAITutor } = props;

  const [context, setContext] = useState({});

  const showRevampChatUI = isAITutor
    ? getIsAITutorModalitiesEnabled()
    : getIsLessonPlanningAIRevampEnabled();

  if (showRevampChatUI) {
    return (
      <LessonPlanningAssistantV2
        {...props}
        context={context}
        setContext={setContext}
      />
    );
  }

  return (
    <LessonPlanningAssistant
      {...props}
      context={context}
      setContext={setContext}
    />
  );
};

export default LessonPlanningAssistantWrapper;
